import { TRefWrapper } from '../types';

/** Дефолтная функция, оборачивающая компоненты, просто возвращает то, что передано на вход */
export const defaultRefWrapper: TRefWrapper = children => children;
